<div *ngIf="iee" class="mask">
    <div class="mask-content">
        <button (click)="close()">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
            </svg>
        </button>
        <p>
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" class="bi bi-exclamation-circle" viewBox="0 0 16 16" style="color: #faad14;">
            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
            <path d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995z"/>
          </svg>
        </p>
        <p>本网站不兼容IE浏览器，不再维护IE浏览器！</p>
        <p>请使用其它浏览器进行访问该网址，如<a href="https://www.google.com/intl/zh-CN/chrome/"> Chrome</a>、<a href="https://browser.360.cn/se/">360</a>、<a href="https://www.microsoft.com/zh-cn/edge/home?form=MA13FJ">Microsoft Edge</a>浏览器等。</p>
    </div>
</div>
<app-nav></app-nav>
<router-outlet></router-outlet>
<footer class="footer mt-auto py-3">
    <div class="container">
        <div class="row org">
            <div class="col">
                <div class="mgl mx-auto">ᠣᠷᠳᠣᠰ ᠬᠤᠲᠠ ᠶᠢᠨ ᠠᠷᠠᠳ ᠤᠨ ᠵᠠᠰᠠᠭ ᠤᠨ ᠣᠷᠳᠣᠨ ᠤ ᠠᠯᠪᠠᠨ ᠭᠡᠷ ᠠᠴᠠ ᠭᠤᠣᠯᠴᠢᠯᠠᠨ ᠡᠷᠬᠢᠯᠡᠪᠡ </div>
                <div class="cn">鄂尔多斯市人民政府办公室主办</div>
            </div>
            <div class="col">
                <div class="mgl mx-auto">ᠣᠷᠳᠣᠰ ᠬᠤᠲᠠ ᠶᠢᠨ ᠦᠦᠰᠢᠨ ᠬᠣᠰᠢᠭᠤᠨ ᠤ ᠪᠢᠯᠢᠭ ᠦᠨ ᠰᠠᠩ ᠨᠣᠮ ᠬᠡᠪᠯᠡᠯ ᠦᠨ ᠮᠦᠽᠧᠢ ᠡᠴᠡ ᠠᠭᠤᠯᠭ᠎ᠠ ᠬᠠᠩᠭᠠᠪᠠ </div>
                <div class="cn">鄂尔多斯市乌审旗毕力贡仓蒙古文图书出版印刷博物馆</div>
            </div>
            <div class="col">
                <div class="mgl mx-auto">ᠥᠪᠥᠷ ᠮᠣᠩᠭᠣᠯ ᠤᠨ ᠣᠨᠣᠨ ᠰᠢᠨᠵᠢᠯᠡᠭᠡ ᠮᠡᠷᠭᠡᠵᠢᠯ ᠦᠨ ᠬᠢᠵᠠᠭᠠᠷᠲᠤ ᠺᠣᠮᠫᠠᠨᠢ ᠠᠴᠠ ᠮᠡᠷᠭᠡᠵᠢᠯ ᠬᠠᠩᠭᠠᠪᠠ </div>
                <div class="cn">内蒙古斡仑科技有限公司提供技术支持</div>
            </div>
        </div>
        <div class="row info">
            <div class="col"><span class="mr-3">©{{ toYear | date: "yyyy" }}</span><span class="icp">蒙ICP备20190711号</span></div>
            <div class="col contact"><span class="mr-3">联系电话：（0477）8589923</span><span>邮箱：ordoszwmgl@163.com</span></div>
            <div class="col"></div>
        </div>
    </div>
</footer>